"use strict";

var _createClass = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/codebuild/output/src788975861/src/whelps.io/node_modules/@babel/runtime/helpers/classCallCheck.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageFormatter = void 0;

var utils_1 = require("../utils");

var utils_2 = require("./utils");

var MessageFormatter = /*#__PURE__*/_createClass(function MessageFormatter() {
  _classCallCheck(this, MessageFormatter);
});

exports.MessageFormatter = MessageFormatter;

MessageFormatter.makeRequest = function (method, params) {
  var id = (0, utils_2.generateRequestId)();
  return {
    id: id,
    method: method,
    params: params,
    env: {
      sdkVersion: (0, utils_1.getSDKVersion)()
    }
  };
};

MessageFormatter.makeResponse = function (id, data, version) {
  return {
    id: id,
    success: true,
    version: version,
    data: data
  };
};

MessageFormatter.makeErrorResponse = function (id, error, version) {
  return {
    id: id,
    success: false,
    error: error,
    version: version
  };
};